export const REQUEST_WEDDING_LIST = "REQUEST_WEDDING_LIST"